<template>
    <Card :title="$route.meta.title" dis-hover style="min-width:1360px;">
        <div slot="extra">
            <Form inline @keydown.enter.native.prevent="refreshGetTableData">
                <FormItem>
                    <Input v-model="query.plateNo" placeholder="车牌号/环保登记号码/所有人/终端号" clearable="" style="width:260px;"></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
                </FormItem>
                <FormItem>
                    <Button type="success" icon="md-add" @click="handleOperation(null,'ADD')">
                        添加
                    </Button>
                </FormItem>
                <FormItem>
                  <Button type="success" icon="md-add" @click="downloadCityVisible = true">市平台下载</Button>
                </FormItem>

                <FormItem>
                    <Upload action="/supervise/admin/equip/uploadEquip" :max-size="10240" :show-upload-list="false"
                            :on-success="handleSuccess"
                            :on-progress="handleProgress"
                            :format="['xls','xlsx']"
                            :on-exceeded-size="handleMaxSize"
                            :before-upload="handleBeforeUpload">
                        <Button icon="ios-cloud-upload-outline">导入</Button>
                    </Upload>
                </FormItem>

                <a href="/supervise/file/template/equip.xlsx" target="_blank" style="display:inline-block;line-height:12px;margin-top:20px;">模板</a>
                <a :href="infoBatchUrl" target="_blank" style="display:inline-block;line-height:12px;margin-top:20px;margin-left:10px;">采集卡批量导出</a>
            </Form>
        </div>
        <Form class="my-form">
            <FormItem label="机械类型：">
                <div class="tag-select">
                    <div><Tag checkable color="primary" :checked="etypeAll.checked" :name="-1" @on-change="etypeChange">{{etypeAll.name}}</Tag></div>
                    <div v-for="(item,index) in etypeTags" :key="index">
                        <Tag checkable color="primary" :checked="item.checked" :name="index" @on-change="etypeChange">{{item.name}}</Tag>
                    </div>
                </div>
            </FormItem>
            <FormItem label="所属地区：" v-if="placeTags">
                <div class="tag-select" style="max-height: 160px;width:80%;overflow: scroll">
                    <div><Tag checkable color="primary" :checked="placeAll.checked" :name="-1" @on-change="placeChange">{{placeAll.name}}</Tag></div>
                    <div  v-for="(item,index) in placeTags" :key="index">
                        <Tag checkable color="primary" :checked="item.checked" :name="index" @on-change="placeChange">{{item.name}}</Tag>
                    </div>
                </div>
            </FormItem>
        </Form>
        <Form inline class="my-form" :label-width="72">
            <FormItem>
                <span slot="label" style="line-height:14px;">定位设备：</span>
                <RadioGroup v-model="query.gpsFlag" @on-change="gpsChange">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="1">未安装</Radio>
                    <Radio :label="2">已安装</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem></FormItem>
            <FormItem v-if="query.gpsFlag==2">
                <span slot="label" style="line-height:14px;">在线状态：</span>
                <RadioGroup v-model="query.terminal.status" @on-change="refreshGetTableData">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="1">在线</Radio>
                    <Radio :label="0">离线</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
        <Form class="my-form">
            <FormItem label="应急抢险：">
                <RadioGroup v-model="query.emergencyRescue" @on-change="refreshGetTableData">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="审核状态：">
                <RadioGroup v-model="query.status" @on-change="refreshGetTableData">
                    <!--<Radio :label="null">全部</Radio>-->
                    <Radio v-for="(item,index) in statusData" :key="index" :label="item.value">{{item.label}}</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="同步状态：">
                <RadioGroup v-model="query.syncStatus" @on-change="refreshGetTableData">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="1">已同步</Radio>
                    <Radio :label="0">未同步</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="同步状态(市)：">
                <RadioGroup v-model="query.syncState" @on-change="refreshGetTableData">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="1">已同步</Radio>
                    <Radio :label="0">未同步</Radio>
                </RadioGroup>
            </FormItem>
        </Form>

        <Form inline @keydown.enter.native.prevent="refreshGetTableData" :label-width="72">
            <Row v-show="showProgress"><Col span="24">
                <div style="margin-bottom:24px;"><Progress :percent="progressPercent" :stroke-width="20" text-inside /></div>
            </Col></Row>
        </Form>

        <Alert v-if="uncheckNum>0" show-icon>还有{{uncheckNum}}条档案数据未审核。</Alert>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="plateNo">
                <span>{{row.plateNo?row.plateNo:'无'}}</span>
            </template>
            <template slot-scope="{row}" slot="emissionStandards">
                <span>{{row.emissionStandards==0?'D':(row.emissionStandards==-1?'x':row.emissionStandards)}}</span>
            </template>
            <template slot-scope="{row}" slot="equipmentType">
                <span>{{row.equipmentType.typeName}}</span>
            </template>
            <template slot-scope="{row}" slot="emergencyRescue">
                <i-switch v-model="row.emergencyRescue" :true-value="1" :false-value="0" @on-change="handleFlagSwitch(row)">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                </i-switch>
            </template>
            <template slot-scope="{row}" slot="terminal">
                <a class="opt-txt" v-if="null==row.terminal||null==row.terminal.id" @click="handleOperation(row,'TERMINAL')">设置终端</a>
                <div v-else  @click="handleOperation(row,'TERMINAL')">
                    <Tooltip v-if="row.terminal.status==1" content="在线" placement="left-start">
                        <span style="color:#19be6b;line-height:1;cursor: pointer;">{{row.terminal.terminalNo}}</span>
                    </Tooltip>
                    <Tooltip v-else content="离线" placement="left-start">
                        <span style="color:#aaa;line-height:1;cursor:pointer;">{{row.terminal.terminalNo}}</span>
                    </Tooltip>
                </div>
            </template>
            <template slot-scope="{row}" slot="syncState">
                <span v-if="row.syncState==null||row.syncState==0">
                    未同步
                    <br/>
                    {{row.syncLog}}
                </span>
              <span v-else>已同步</span>
              <p v-if="row.syncTime">同步时间:{{row.syncTime}}</p>
            </template>
            <template slot-scope="{row}" slot="syncStatus">
              <span v-if="row.syncStatus==null||row.syncStatus==0">未同步</span>
              <span v-else>已同步</span>
            </template>
            <template slot-scope="{row}" slot="status">
                <span>{{findStatusName(row.status)}}</span>
            </template>

            <template slot-scope="{row}" slot="operation">
                <a class="opt-txt" v-if="row.status==1" @click="handleOperation(row,'RECEIVE')">领取标牌</a>
                <a class="opt-txt" v-if="row.status!=1" @click="handleOperation(row,'AUDIT')">审核</a>
                <a class="opt-txt" @click="handleOperation(row,'EDIT')">编辑</a>
                <a class="opt-txt" @click="handleOperation(row,'DELETE')">删除</a>
                <Dropdown :transfer="true">
                    <a href="javascript:void(0)">
                        导出
                        <Icon type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list">
                        <DropdownItem><a :href="downHref(row, 0)" target="_blank">采集卡</a></DropdownItem>
                        <DropdownItem><a :href="downHref(row, 1)" target="_blank">登记证正面</a></DropdownItem>
                        <DropdownItem><a :href="downHref(row, 2)" target="_blank">登记证反面</a></DropdownItem>
                        <DropdownItem><a :href="downHref(row, 3)" target="_blank">设备档案证</a></DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </template>
        </Table>
        <page-model :paging="page" :total="total" :size_opts="size_opts" @page-change="handlePageChange"></page-model>

        <equip-edit v-model="modalVisible" :dataSource="modalData" @on-success="getTableData"></equip-edit>
        <equip-check v-model="checkVisible" :dataSource="modalData" @on-success="getTableData"></equip-check>
        <report-edit v-model="reportVisible" :equipId="equipId" @on-success="getTableData"></report-edit>
        <receive-edit v-model="receiveVisible" :equipId="equipId" @on-success="getTableData"></receive-edit>
        <terminal-edit v-model="terminalVisible" @on-success="getTableData" :equipId="equipId" :terminalId="terminalId"></terminal-edit>
        <download-city v-model="downloadCityVisible" @on-success="getTableData"></download-city>
    </Card>
</template>
<script>
    import iEquip from '@/module/main/api/iEquip';
    import tableHelper from '@/mixins/tableHelper';
    import rules from '@/libs/rules';
    import DoPicture from '@/components/auto-form/DoPicture';
    import EquipSearch from '@/module/main/components/EquipSearch';
    import EquipEdit from '@/module/main/components/EquipEdit';
    import EquipCheck from '@/module/main/components/EquipCheck';
    import DownloadCity from '@/module/main/components/DownloadCity';
    import ReceiveEdit from '@/module/main/components/ReceiveEdit';
    import ReportEdit from '@/module/main/components/ReportEdit';
    import TerminalEdit from '@/module/main/components/TerminalEdit';
    import PlaceSel from '@/module/main/components/PlaceSel';
    import EtypeSel from '@/module/main/components/EtypeSel';
    import _don from '@/libs/doson'

    const modalFormTemplate = {
        id:null,
        emergencyRescue:0,
    };

    export default {
        name: "archive_mng",
        mixins: [tableHelper],
        components: {
            DoPicture,EquipSearch,EquipEdit,ReportEdit,EquipCheck,ReceiveEdit,TerminalEdit,PlaceSel,EtypeSel,DownloadCity
        },
        data() {
            return {
                rules,
                statusData:[
                    {value:null,label:'全部'},
                    {value:0,label:'未审核'},
                    {value:1,label:'通过'},
                    {value:2,label:'未通过'},
                ],
                query:{
                    status:null,
                    syncState:null,
                    plateNo:null,
                    emergencyRescue:null,
                    epNo:null,
                    equipmentType:{id:null},
                    place:{id:null},
                    gpsFlag:null,
                    syncStatus:null,
                    terminal:{status:null},
                    etypes:null,
                    places:null
                },
                tableColumns:[
                    {title: '序号', key: 'idx', width: 80},
                    {title: '环保登记号码', key: 'epNo', width: 120},
                    {title: '车牌号', slot: 'plateNo', width: 100},
                    {title: '所有人', key: 'ownerName'},
                    /*{title: '联系方式', key: 'ownerContact'},*/
                    {title: '排放阶段', slot: 'emissionStandards', width: 100},
                    {title: '机械类型', slot: 'equipmentType'},
                    {title: '使用地点', key: 'usedPlace'},
                    {title: '应急抢险', slot: 'emergencyRescue'},
                    {title: '终端号', slot: 'terminal'},
                    {title: '同步状态(市)', slot: 'syncState'},
                    {title: '同步状态', slot: 'syncStatus'},
                    {title: '审核状态', slot: 'status'},
                    {title: '操作', slot: 'operation',width:200}
                ],

                modalTitle:'添加档案',
                modalVisible:false,
                modalData:{},

                reportVisible:false,
                equipId:0,

                checkVisible:false,
                receiveVisible:false,

                imgUrl:'',
                voucherShow:false,

                terminalVisible:false,
                terminalId:0,

                showProgress:false,
                progressPercent:0,

                parsedUplod:[],
                parsedTotal:1,
                addTotal:0,

                placeAll:{
                    checked:true,
                    value:1,
                    name:'全部'
                },
                placeTags:null,
                etypeAll:{
                    checked:true,
                    value:1,
                    name:'全部'
                },
                etypeTags:null,

                rescueData:{},

                uncheckNum:0,
                size_opts:[5, 8,10,20,30,50,100],

                downloadCityVisible: false
            }
        },
        mounted() {
            iEquip.etypeList().then(res=>{
                this.etypeTags = [...res.map(e=>{
                        return {checked:true,value:e.id,name:e.typeName}
                    })]
            })
            iEquip.placeAll({level:2}).then(res=>{
                if (res.length > 0) {
                    this.placeTags = [...res.map(e=>{
                        return {checked:true,value:e.id,name:e.placeName}
                    })];
                }

            })
            this.getTableData()
        },
        methods: {
            flatPlaces(places) {
                let arr = []
                for (var i = 0; i < places.length; i++) {
                    arr.push.apply(arr,places[i].children)
                }
                return arr
            },
            getTableData() {
                iEquip.equipList(this.page, this.query).then(res => {
                    var i = 1
                    var _th = this
                    this.tableList = res.content.map(e => {
                        e.idx = (_th.page.page-1)*_th.page.size+i++
                        e.equipImport = e.equipImport ? 1 : 0
                        return e
                    });
                    this.total = res.totalElements
                }).loadingSwitch(this, 'tableLoading');
                iEquip.uncheckNum().then(res => {
                    this.uncheckNum = res
                });
            },
            showVoucher(voucher) {
                this.imgUrl = voucher
                this.voucherShow = true
            },
            async handleOperation(row, type) {
                if (type === 'ADD') {
                    this.modalData = {}
                    this.modalVisible = true
                    return;
                }
                if (type === 'TERMINAL') {
                    this.equipId = row.id
                    if (row.terminal && row.terminal.id) {
                        this.terminalId = row.terminal.id;
                    } else {
                        this.terminalId = 0
                    }
                    this.terminalVisible = true;
                    return;
                }
                if (type === 'RECEIVE') {
                    this.equipId = row.id
                    this.receiveVisible = true
                    return;
                }
                if (type === 'EDIT') {
                    this.modalData = row
                    this.modalVisible = true
                    return;
                }
                if (type === 'AUDIT') {
                    this.modalData = row
                    this.checkVisible = true
                    return;
                }
                if (type === 'DELETE') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `将删除该机械信息，确认继续？`,
                        onOk: () => {
                            iEquip.equipDelete(row.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }
                /*if (type === 'CITYSYNC') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `同步数据到市平台，确认继续？`,
                        onOk: () => {
                            iEquip.syncCity(row.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).catch(err=>{
                                this.$Message.error(err);
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }*/
            },
            handleSubmit() {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    iEquip.insuranceAdd(this.modalForm).then(() => {
                        this.$Message.success('操作成功');
                        this.getTableData()
                        this.modalVisible = false
                    });
                });
            },
            handleFlagSwitch(row) {
                // 重置表单
                _don.cloneWithModal(modalFormTemplate, this.rescueData, row);
                /*console.log(this.modalData.equipUuid)
                console.log(row.equipUuid)
                console.log(this.modalData.emergencyRescue)*/
                iEquip.equipUpdate(this.rescueData).then(() => {
                    this.$Message.success('操作成功');
                    this.getTableData()
                });
            },
            sChange(v) {
                this.modalForm.startTime = v
            },
            eChange(v) {
                this.modalForm.endTime = v
            },
            findStatusName(status) {
                let finded = this.statusData.find(e=>e.value==status)
                return finded ? finded.label:'未知'
            },
            handleMaxSize(e) {
                console.log(e)
                this.$Message.error('文件大小超限，不能超过10M')
            },
            handleSuccess(res) {
                let _th = this
                this.showProgress = false
                this.progressPercent = 0
                if (res.success) {
                    if (!res.data || res.data.length == 0) {
                        this.$Message.error('未解析到有效数据,请检查文件内容是模板是否一致')
                    } else {
                        this.parsedUplod = res.data
                        this.parsedTotal = this.parsedUplod.length
                        this.addTotal = 0
                        this.$Modal.confirm({
                            title:'解析到' + res.data.length + '数据，是否添加',
                            onOk() {
                                _th.startAdd()
                            }
                        });
                    }
                } else {
                    this.$Message.error(res.message)
                }
            },
            handleProgress(e) {
                this.progressPercent = e.percent
            },
            handleBeforeUpload() {
                this.showProgress = true
                this.progressPercent = 0
            },
            startAdd() {
                if (this.parsedUplod.length == 0) {
                    this.showProgress = false
                    this.parsedTotal = 1
                    this.addTotal = 0
                    return
                }
                if (this.addTotal == 0) {
                    this.showProgress = true
                    this.progressPercent = 0
                }
                iEquip.equipAdd(this.parsedUplod.pop()).then(res => {
                    this.addTotal = this.addTotal + 1
                    if(this.addTotal < this.parsedTotal){
                        this.progressPercent = this.formatPercent(this.addTotal*100/this.parsedTotal)
                        this.startAdd()
                    } else {
                        this.showProgress = false
                        this.parsedTotal = 1
                        this.addTotal = 0
                        this.$Message.success('添加完成')
                        this.getTableData()
                    }
                }).catch(err => {
                    this.addTotal = this.addTotal + 1
                    this.$Notice.error({
                        title:'错误提醒',
                        desc:err,
                        duration:0
                    })
                    if(this.addTotal < this.parsedTotal){
                        this.progressPercent = this.formatPercent(this.addTotal*100/this.parsedTotal)
                        this.startAdd()
                    } else {
                        this.showProgress = false
                        this.parsedTotal = 1
                        this.addTotal = 0
                        this.$Message.success('添加完成')
                        this.getTableData()
                    }
                });
            },
            formatPercent(val) {
                if (!val) {
                    return 0
                }
                return Math.round(val*100)/100
            },
            etypeChange(checked,name) {
                var i = parseInt(name)
                if (i < 0) {
                    this.etypeAll.checked = checked
                    this.etypeTags.forEach((v)=>{
                        v.checked = checked
                    })
                } else {
                    this.etypeTags[i].checked = checked
                    !checked && (this.etypeAll.checked = false)
                    checked && (this.etypeAll.checked = this.etypeTags.filter(e=>!e.checked).length == 0)
                }

                this.query.etypes = this.etypeAll.checked?[]:[-1,...this.etypeTags.filter(e=>e.checked).map(e=>e.value)]
                this.getTableData()
            },
            placeChange(checked,name) {
                var i = parseInt(name)
                if (i < 0) {
                    this.placeAll.checked = checked
                    this.placeTags.forEach((v)=>{
                        v.checked = checked
                    })
                } else {
                    this.placeTags[i].checked = checked
                    !checked && (this.placeAll.checked = false)
                    checked && (this.placeAll.checked = this.placeTags.filter(e=>!e.checked).length == 0)
                }

                this.query.places = this.placeAll.checked?[]:[-1,...this.placeTags.filter(e=>e.checked).map(e=>e.value)]
                this.getTableData()
            },
            gpsChange() {
                if (this.query.gpsFlag != 2) {
                    this.query.terminal.status = null
                }
                this.getTableData()
            },
            downHref(item, type) {
                var typeArr = ['InfoCard','RegistryFront','RegistryVerso','Archive']
                return '/supervise/admin/equip/down'+typeArr[type]+'?id=' + item.id
            }
        },
        computed: {
            infoBatchUrl() {
                let url = '/supervise/admin/equip/downInfoCardBatch?ids='
                let idArray = this.tableList.map(i => {
                    return i.id
                })
                url += idArray.toString()
                return url
            }
        }
    }
</script>

<style lang="less">
    .tag-select{
        display:flex;
        flex-wrap: wrap;

        &>div{
            padding:0 5px;
        }
    }
    .ivu-card{
        div.ivu-card-extra{
            top:7px;
        }
    }
    .my-form{
        .ivu-form-item{
            margin-bottom:12px;
        }
    }
</style>
